"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: subheadlineRef,
    isVisible: subheadlineVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.3
  });
  const videoRef = useRef<HTMLVideoElement>(null);
  const [scrollY, setScrollY] = useState(0);
  const [isHovered, setIsHovered] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    if (videoRef.current) {
      if (isHovered) {
        videoRef.current.pause();
      } else {
        videoRef.current.play().catch(() => {});
      }
    }
  }, [isHovered]);
  const parallaxScale = 1 + scrollY * 0.0002;
  return <section id="hero" className="relative w-full h-screen overflow-hidden bg-dark-background" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)}>
      {}
      <div className="absolute inset-0 transition-transform duration-slow ease-smooth" style={{
      transform: `scale(${Math.min(parallaxScale, 1.02)})`
    }}>
        <video ref={videoRef} className="w-full h-full object-cover" autoPlay muted loop playsInline poster="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1529178/img/hero_video_poster.png">
          <source src="/img/hero_background_video.mp4" type="video/mp4" />
        </video>
        <div className="absolute inset-0 bg-primary/60" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center justify-center h-full px-4 text-center">
        {}
        <h1 ref={headlineRef} className="font-display text-4xl font-bold max-w-4xl mb-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] opacity-100 translate-y-0 !text-[hsl(0,0%,100%)] md:text-5xl lg:text-6xl">Cinematic Video & Premium Photography for Brands and Events.</h1>

        {}
        <p ref={subheadlineRef} className="font-sans text-lg max-w-3xl mb-8 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-100 opacity-100 translate-y-0 !text-[hsl(0,0%,100%)] md:text-xl lg:text-2xl">
          We create high-impact content that looks expensive, feels emotional,
          and converts.
        </p>

        {}
        <div ref={ctaRef} className={`flex flex-col sm:flex-row gap-4 transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] delay-200 ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          <Link to="/ContactPage">
            <Button size="lg" className="bg-accent text-foreground-accent border-2 border-accent hover:bg-accent-hover hover:border-accent-hover hover:-translate-y-0.5 hover:shadow-medium active:bg-accent-active active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-6 text-base font-semibold">
              Book a Call
            </Button>
          </Link>
          <Link to="/ContactPage">
            <Button size="lg" variant="outline" className="bg-transparent text-foreground-dark border-2 border-accent hover:bg-accent/10 hover:border-accent-hover hover:-translate-y-0.5 hover:shadow-medium active:translate-y-0 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] px-8 py-6 text-base font-semibold">
              Get a Quote
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}